export default __webpack_public_path__ + "static/media/ensure-gold.18a244d4.jpg";